import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import PatternPageContent from '../../components/shop/PatternPageContent';
import { loadPatternPreview } from '../../utils/patternPreview';

export default function PatternPreview() {
  const [searchParams] = useSearchParams();
  const key = searchParams.get('key');
  const storage = typeof window !== 'undefined' ? window.localStorage : null;
  const pattern = loadPatternPreview(storage, key);

  if (!pattern) {
    return (
      <div className="container mx-auto px-4 py-20 text-center">
        <h1 className="text-2xl font-bold mb-4">Preview unavailable</h1>
        <p className="mb-6 text-gray-600">Return to the pattern editor and open a new preview.</p>
        <Link to="/admin/patterns" className="text-primary hover:underline">Back to patterns</Link>
      </div>
    );
  }

  return <PatternPageContent pattern={pattern} isPreview />;
}
